import { Toaster } from "react-hot-toast";
import "./App.css";
import OrderManagementPage from "./pages/orders";

function App() {
  return (
    <>
      <OrderManagementPage />
      <Toaster />
    </>
  );
}

export default App;
